module.exports = __webpack_public_path__ + "img/iron-throne-1.6086c843.png";